$(function () {
  addModalProject('js-modalFind-a', modalData.personA,'a');
  addModalProjectSecret('js-modalFind-a-secret', modalData.personASecret,'a');
  addModalProject('js-modalFind-b', modalData.personB,'b');
  addModalProjectSecret('js-modalFind-b-secret', modalData.personBSecret,'b');
  addModalProject('js-modalFind-c', modalData.personC,'c');
  addModalProjectSecret('js-modalFind-c-secret', modalData.personCSecret,'c');

  specialChangePersonB2();
});

  // -------------- totop --------------
  $(document).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $("#totop").stop().animate({
        bottom: "100px"
      }, 500);
    } else {
      $("#totop").stop().animate({
        bottom: "-80px"
      }, 500);
    }
  });
  $("#totop").click(function (e) {
    $("html,body").stop().animate({
      scrollTop: "0"
    }, 1000);
  });

  
function addModalProject(person, data,addPerson) {
  var target = document.getElementById(person);
  var allProject = [];
  for (var i = 0; i < data.length; i++) {
    var num = i + 1;
    var project = `
      <div class="project find-` + addPerson + `-` + num + `">
        <div class="project--mobileBox">
          <div class="project__pic">
            <img src="images/modal/find-` + addPerson + `/find-` + addPerson + `-` + num + `.png" alt="">
          </div>
          <div class="project__tag">
            <span class="project__tag__num">
              <em>` + num + `</em>
            </span>
            <div class="project__tag__text">
              <h5 class="c-titleH5">` + data[i].project + `</h5>
              <p class="mb-0">` + data[i].text + `</p>
            </div>
          </div>
        </div>
      </div>
    `;
    allProject += project;
  }
  target.innerHTML = allProject;
}

function addModalProjectSecret(person, data,addPerson) {
  var target = document.getElementById(person);
  var allProject = [];
  for (var i = 0; i < data.length; i++) {
    var num = i + 1;
    var project = `
      <div class="project find-` + addPerson + `-secret-` + num + `">
        <div class="project--mobileBox">
          <div class="project__pic">
            <img class="project__pic__img--secret" src="images/modal/find-` + addPerson + `/find-` + addPerson + `-secret-` + num + `-hide.png" alt="">
            <img src="images/modal/find-` + addPerson + `/find-` + addPerson + `-secret-` + num + `-show.png" alt="">
          </div>
          <div class="project__tag">
            <span class="project__tag__num project__tag__num--secret">
              <em>祕</em>
            </span>
            <div class="project__tag__text project__tag__text--secret">
              <h5 class="c-titleH5">` + data[i].project + `</h5>
              <p class="mb-0">` + data[i].text + `</p>
            </div>
          </div>
        </div>
      </div>
    `;
    allProject += project;
  }
  target.innerHTML = allProject;
}

function specialChangePersonB2(){
  // $('.find-b-2').remove();
  var changeB2Content = `
    <div class="project find-b-2">
      <div class="project--mobileBox">
        <div class="project__pic">
          <img src="images/modal/find-b/find-b-2.png" alt="">
        </div>
        <div class="project__tag">
          <span class="project__tag__num">
            <em>2</em>
          </span>
          <div class="project__tag__text">
            <h5 class="c-titleH5">99% 巧克力</h5>
            <p class="mb-0">有苦在心口難開 99%巧克力都是甜的</p>
            <hr>
            <h5 class="c-titleH5">絲巾</h5>
            <p class="mb-0">下屬出包，心寒靠保暖</p>
            <hr>
            <h5 class="c-titleH5">打火機</h5>
            <p class="mb-0">姊抽的不是菸，是截稿壓力</p>
          </div>
          </p>
        </div>
      </div>
    </div>
  `;
  $('.find-b-2').html(changeB2Content);
} 